import { render, staticRenderFns } from "./ModelInformationCard.vue?vue&type=template&id=c77bd4b2&scoped=true"
import script from "./ModelInformationCard.vue?vue&type=script&lang=ts"
export * from "./ModelInformationCard.vue?vue&type=script&lang=ts"
import style0 from "./ModelInformationCard.vue?vue&type=style&index=0&id=c77bd4b2&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c77bd4b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c77bd4b2')) {
      api.createRecord('c77bd4b2', component.options)
    } else {
      api.reload('c77bd4b2', component.options)
    }
    module.hot.accept("./ModelInformationCard.vue?vue&type=template&id=c77bd4b2&scoped=true", function () {
      api.rerender('c77bd4b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Viewer/Info/ModelInformationCard.vue"
export default component.exports